<template>
  <div class="edit_main">
    <Form
      class="fx_1"
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate"
      :label-width="100"
      inline
    >
      <FormItem label="用户名" prop="userName">
        <Input class="w-250" v-model="addModel.userName"></Input>
      </FormItem>
      <FormItem label="用户编号" prop="userCode">
        <Input class="w-250" v-model="addModel.userCode"></Input>
      </FormItem>

      <FormItem label="用户类型" prop="userType">
        <Select class="w-250" v-model="addModel.userType">
          <Option
            v-for="(item, index) in userTypeSelect"
            :value="item.dictionaryID"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="英文名">
        <Input class="w-250" v-model="addModel.userNameEN"></Input>
      </FormItem>
      <FormItem label="性别">
        <Select class="w-250" v-model="addModel.userSex" clearable>
          <Option value="0">男</Option>
          <Option value="1">女</Option>
        </Select>
      </FormItem>
      <FormItem label="身份证号">
        <Input class="w-250" v-model="addModel.idCardNO"></Input>
      </FormItem>
      <FormItem label="出生日期">
        <DatePicker
          v-model="addModel.userBirth"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>
      <FormItem label="入职日期">
        <DatePicker
          v-model="addModel.entryDate"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>
      <FormItem label="离职日期">
        <DatePicker
          v-model="addModel.quitDate"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>

      <FormItem label="手机号">
        <Input class="w-250" v-model="addModel.userMobile"></Input>
      </FormItem>
      <FormItem label="座机号">
        <Input class="w-250" v-model="addModel.userTell"></Input>
      </FormItem>
      <FormItem label="邮箱">
        <Input class="w-250" v-model="addModel.userEmail"></Input>
      </FormItem>
      <FormItem label="住址">
        <Input class="w-250" v-model="addModel.userAddress"></Input>
      </FormItem>

      <FormItem label="选择科室" required>
        <Button type="primary" @click="treeModel = true">选择科室</Button>
        <span class="ml-5">{{ addModel.departmentName }}</span>
      </FormItem>

      <FormItem label="备注" class="show">
        <Input
          class="w-250"
          v-model="addModel.userRemark"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 8 }"
        ></Input>
      </FormItem>
      <FormItem label="签名">
        <Upload
          ref="uploadFile"
          :action="uploadUrl"
          :headers="headers"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <!-- :show-upload-list="false" -->
          <Button icon="ios-cloud-upload-outline">选择图片</Button>
        </Upload>
        <img
          style="max-width: 500px; max-height: 500px"
          v-bind:src="signimageUrl"
        />
      </FormItem>
    </Form>

    <div class="edit_btn_group">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')"
        >确 定</Button
      >
    </div>

    <Modal
      v-model="treeModel"
      width="800px"
      title="选择科室"
      :footer-hide="true"
    >
      <departmentSelect @selectDepartment="selectDepartment"></departmentSelect>
    </Modal>
    <!-- <Modal
      v-model="refreah_show"
      width="800px"
      title="提示"
      
    >
      <div>添加成功</div>
      <div>初始密码为：111111</div>
    </Modal> -->
  </div>
</template>
<script>
import departmentSelect from "../department/departmentSelect.vue";
import token from "../../../utils/token.js";

export default {
  components: { departmentSelect },
  data: function () {
    return {
      // refreah_show: false,
      treeModel: false,
      organParentName: "",
      headers: "",
      uploadUrl: "",
      signimageUrl: "",
      addModel: {
        userName: "",
        userCode: "",
        userType: "",
        userNameEN: "",
        userSex: "",
        userBirth: null,
        entryDate: null,
        quitDate: null,
        idCardNO: "",
        userMobile: "",
        userTell: "",
        userAddress: "",
        userEmail: "",
        userRemark: "",

        organID: "",
        organName: "",
        departmentID: "",
        departmentName: "",
        signImage: "",
      },
      ruleValidate: {
        userName: [
          {
            required: true,
            message: "用户名不能为空",
          },
        ],
        userCode: [
          {
            required: true,
            message: "用户编号不能为空",
          },
        ],
        userType: [
          {
            required: true,
            message: "用户类型不能为空",
          },
        ]
      },
      userTypeSelect: [],
    };
  },

  activated () {
    // this.resetData()
    this.$common.getDictionary("用户类型").then((data) => {
      this.userTypeSelect = data;
    });
    let baseUrl = localStorage.getItem("baseURL");
    this.uploadUrl = baseUrl + "/user/UploadImage";
    this.headers = { Authorization: "Bearer " + token.getToken() };
  },

  methods: {
    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },
    returnBack: function () {
      this.$router.push("user");
      // this.$bus.$emit('refresh')
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (!this.addModel.departmentID) {
            this.$Message.warning("请选择所属科室");
            return;
          }
          this.addModel.userBirth =
            this.addModel.userBirth == "" ? null : this.addModel.userBirth;
          this.addModel.entryDate =
            this.addModel.entryDate == "" ? null : this.addModel.entryDate;
          this.addModel.quitDate =
            this.addModel.quitDate == "" ? null : this.addModel.quitDate;
          this.$api.post("user/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.resetData()
            //  this.refreah_show = true
              this.$Modal.success({
                title: "添加成功",
                content: "初始密码为：Abc123456+"
              });
              // this.$Message.success("添加成功,初始密码为：111111");
              // this.$router.push({ path: "/basedata/department" });
              this.returnBack();
            }
          });
        }
      });
    },

    selectDepartment: function (data) {
      this.treeModel = false;
      this.addModel.departmentID = data.departmentID;
      this.addModel.departmentName = data.departmentName;
      this.addModel.organID = data.organID;
      this.addModel.organName = data.organName;
    },
    //导入
    uploadSuccess: function (response, file, fileList) {
      if (response.statusCode == 200) {
        this.$Message.success("上传成功");

        this.addModel.signImage = response.data;

        this.fileName = file.name;
        this.signimageUrl = localStorage.getItem("baseURL") + response.data;
      } else {
        this.$Message.success(response.msg);
      }
    },

    cancel: function () {},
    uploadError: function (error, file, fileList) {
      this.$Message.success("上传失败");
    },
  },
};
</script>
<style scoped>
</style>